/**
 * Admin 라우트 admin.site.work-templates.*
 * - create/edit: 메타 폼 + 라이브 미리보기 (legacy bootEditor)
 * - canvas: 썸네일 기반 구조 빌더 (WorkTemplateThumbCanvas)
 */
import { Logger } from "../../utils/Logger";
import { AdminIndexTable } from "../components/AdminIndexTable";
import { WorkTemplateBlocksBuilder } from "../work-template/WorkTemplateBlocksBuilder";
import { WorkTemplatePreviewPanel } from "../work-template/WorkTemplatePreviewPanel";
import { WorkTemplateThumbCanvas } from "../work-template/WorkTemplateThumbCanvas";

const CTRL_TAG = "AdminWorkTemplateController";

function bootEditor(root: HTMLElement): void {
    const form = root.querySelector<HTMLFormElement>("form.admin-form[data-admin-ajax='1']");
    const previewPanel = new WorkTemplatePreviewPanel(root);

    const blocksBuilder = new WorkTemplateBlocksBuilder(root, {
        onStructureChange: () => previewPanel.scheduleRefresh(),
    });
    blocksBuilder.init();

    if (form) {
        blocksBuilder.bindSubmitReindex(form);
    }

    const list = blocksBuilder.getList();
    if (form && list) {
        previewPanel.init(list, form);
    }
}

export const AdminWorkTemplateController = {
    index(): void {
        Logger.debug(`${CTRL_TAG}.index`);
        new AdminIndexTable({ pageSelector: ".admin-work-templates" }).init();
    },
    create(): void {
        Logger.debug(`${CTRL_TAG}.create`);
        const root = document.querySelector<HTMLElement>(".admin-work-templates");
        if (!root) return;
        bootEditor(root);
    },
    edit(): void {
        Logger.debug(`${CTRL_TAG}.edit`);
        const root = document.querySelector<HTMLElement>(".admin-work-templates");
        if (!root) return;
        bootEditor(root);
    },
    /** 템플릿 CMS 캔버스 — 썸네일 기반 구조 빌더 (라이브 미리보기 없음). */
    canvas(): void {
        Logger.debug(`${CTRL_TAG}.canvas`);
        const root = document.querySelector<HTMLElement>(".admin-work-templates--canvas-thumb");
        if (!root) return;
        new WorkTemplateThumbCanvas(root).init();
    },
    store(): void {
        Logger.debug(`${CTRL_TAG}.store (no-op)`);
    },
    update(): void {
        Logger.debug(`${CTRL_TAG}.update (no-op)`);
    },
    destroy(): void {
        Logger.debug(`${CTRL_TAG}.destroy (no-op)`);
    },
};
